import { createSelector, createFeatureSelector } from '@ngrx/store';
import { State } from './statements.reducer';
import { DocumentsData, DocumentsFilter } from './statements.models';
import { FilterInfo, SortInfo } from '../../global/interfaces';
import { PaginationInfo } from 'atlas-pagination';

export const selectStatementsState = createFeatureSelector<State>('statements');

export const selectStatementsLoading = createSelector(selectStatementsState, (state: State) => state.loading);

export const selectStatementsDocuments = createSelector(selectStatementsState, (state: State) => state.documents);

export const selectStatementsDocumentsData = createSelector(selectStatementsDocuments, (state: DocumentsData) => state.data);

export const selectStatementsDocumentsTotal = createSelector(selectStatementsDocuments, (state: DocumentsData) => state.total);

export const selectStatementsMobile = createSelector(selectStatementsState, (state: State) => state.mobile);

export const selectStatementsMobileData = createSelector(selectStatementsMobile, (state: DocumentsData) => state.data);

export const selectStatementsMobilePagination = createSelector(selectStatementsState, (state: State) => state.mobilePagination);

export const selectStatementsFilter = createSelector(selectStatementsState, (state: State) => state.filter);

export const selectStatementsFilterType = createSelector(selectStatementsFilter, (state: DocumentsFilter) => state.type);

export const selectStatementsFilterFrom = createSelector(selectStatementsFilter, (state: DocumentsFilter) => state.from);

export const selectStatementsFilterTo = createSelector(selectStatementsFilter, (state: DocumentsFilter) => state.to);

export const selectStatementsSort = createSelector(selectStatementsState, (state: State) => state.sort);

export const selectStatementsPagination = createSelector(selectStatementsState, (state: State) => state.pagination);

export const selectStatementsTypes = createSelector(selectStatementsState, (state: State) => state.types);

export const selectStatementsMobileLoadParameters = createSelector(
  selectStatementsMobile,
  selectStatementsFilter,
  selectStatementsSort,
  selectStatementsMobilePagination,
  (mobile, filter, sort, mobilePagination) =>
    ({ mobile, filter, sort, mobilePagination })
);


export const selectStatementsPayloadData = createSelector(
  selectStatementsSort,
  selectStatementsPagination,
  (sort: SortInfo, pagination: PaginationInfo) =>
  /**
   * Combine selectors in order to avoid infinite loops when pagination totalCount changes
   */
  ({
    sort,
    pagination: {
      ...pagination,
      page: pagination.page,
      itemsByPage: pagination.itemsByPage
    },
  }
  )
);
